import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./fixed-footer-layout.css.ts.vanilla.css-mistica.js";
var a = "p5j8j5d _1y2v1nfl6 _1y2v1nfll _1y2v1nfhf", f = "p5j8j57", n = "p5j8j55", o = "p5j8j5b _1y2v1nfkr _1y2v1nfl6 _1y2v1nfll _1y2v1nfm0 _1y2v1nfhg", j = "p5j8j54", y = "p5j8j53 _1y2v1nfi7", e = "p5j8j59 _1y2v1nfkr _1y2v1nfl6 _1y2v1nfll _1y2v1nfm0 _1y2v1nfhg", _ = {
    footerHeight: "var(--p5j8j50)",
    backgroundColor: "var(--p5j8j51)"
}, t = "_1y2v1nfhj";
export { a as absoluteBackgroundLayer, f as container, n as elevated, o as fixedBackgroundLayer, j as fixedFooter, y as footer, e as portal, _ as vars, t as withoutFooter };
